export default {
	namespaced: true,

	state: {
		pageName: null,
		pageType: null,

		data: {
		//	questionKey: {
		//		order: '',
		//
		//		type: ''
		//
		//		question: {
		//			title: '',
		//			text: '',
		//		}
		//
		//		(checkbox)
		//		answer: {
		//			answerKey1: {
		//				order: 10,
		//				text: 'Answer Text'
		//				isCorrectAnswer: true/false
		//				value: true/false,
		//			}
		//		}
		//
		//		(combo box - select option)
		//		answer: {
		//			order: 10,
		//			text: ''
		//			key: answerKey
		//		}
		//
		//		(combo box - free text)
		//		answer: 'Answer Text'
		//
		//		(combo box - multiple)
		//		answer: [
		//			{
		//				order: 10,
		//				text: ''
		//				key: answerKey
		//			},
		//			'Answer Text'
		//		]
		//
		//		(radio button)
		//		answer: {
		//			order: 10,
		//			text: ''
		//			key: answerKey
		//			isCorrectAnswer: true/false
		//		}
		//
		//		(select)
		//		answer: {
		//			order: 10,
		//			text: ''
		//			key: answerKey
		//		}
		//
		//		(select - multiple)
		//		answer: [
		//			{
		//				order: 10,
		//				text: ''
		//				key: answerKey
		//			}
		//		]
		//
		//		(slider)
		//		answer: 0
		//
		//		(switch)
		//		answer: {
		//			answerKey1: {
		//				order: 10,
		//				text: 'Answer Text'
		//				value: true/false,
		//			}
		//		}
		//
		//		(text field / textarea)
		//		answer: 'Answer Text'
		//
		//		score: 10
		//		isCorret: true/false
		//	}
		}
	},

	getters: {
		get: state => state
	},

	mutations: {
		setValue (state, [key, value]) {
			state[key] = value;
		},
		setSubValue (state, [key, subKey, value]) {
			state[key][subKey] = value;
		}
	},

	actions: {
	}
}
